import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';
import RightArrow from '../../../images/icons/arrow-right.inline.svg';

const BrandedTableContainer = styled.div`
    background-color: #f2f0eb;
    padding: 100px 0;
    .title-container {
        text-align: center;
        margin-bottom: 20px;
        ${media.large`margin-bottom: 30px;`}
        h3 {
            font-size: 2.4rem;
            color: #000;
            font-weight: 800;
            margin: 0 0 25px;
            font-family: neue-kabel, sans-serif;
        }

        p {
            max-width: 600px;
            margin: 0 auto;
        }
    }
    .table-container {
        position: relative;
        max-width: 600px;
        margin: 0 auto 50px;

        table {
            background-color: #ffffff;
            border-radius: 0px 0px 4px 4px;
            box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
            margin-bottom: 30px;
            ${media.medium`margin-bottom: 0px;`}
            thead {
                th {
                    background-color: #0f1212;
                    color: #fff;
                    padding: 20px 30px;
                    font-size: 0.9rem;
                }
            }
            tbody {
                td {
                    padding: 15px 30px;
                    font-size: 0.8rem;
                    color: #000;
                    border: none;
                }
            }
        }

        .btn-container {
            text-align: center;
            ${media.medium`position: absolute;bottom: 25%;right: -35%;`}
            ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    margin-bottom: 10px;

                    &:first-child {
                        a {
                            color: #fff;
                            background-color: #f74d33;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            text-decoration: none;
                            padding: 20px 30px;
                            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                            border-radius: 5px;
                            font-size: 1.5rem;
                            display: inline-block;
                            border: 1px solid #f74d33;
                            ${TransitionMixin('.25s')}

                            &:hover {
                                background-color: transparent;
                                color: #f74d33;

                                span {
                                    text-align: left;
                                    svg {
                                        path {
                                            fill: #f74d33;
                                        }
                                    }
                                }
                            }

                            span {
                                position: relative;
                                top: 3px;
                                margin-left: 40px;
                            }
                        }
                    }
                    &:nth-child(2) {
                        a {
                            color: #fff;
                            background-color: #1c7775;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            text-decoration: none;
                            padding: 20px 30px;
                            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                            border-radius: 5px;
                            font-size: 1rem;
                            display: inline-block;
                            border: 1px solid #1c7775;

                            ${TransitionMixin('.25s')}

                            &:hover {
                                background-color: transparent;
                                color: #1c7775;
                            }
                        }
                    }
                }
            }
        }
    }

    .table-footer-container {
        text-align: center;
        max-width: 500px;
        margin: 0 auto;
        p {
            font-size: 0.9rem;
            margin-bottom: 0px;
        }
    }
`;

const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr && arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
    );

const BrandedTable = ({ content }) => {
    const {
        sectionTitle,
        sectionBlurb,
        tableHeaders,
        tableBodyCells,
        sectionFooterBlurb,
        smallTableButton,
        largeTableButton,
    } = content || {};

    let cellArray = chunk(tableBodyCells, tableHeaders && tableHeaders.length);

    function createFooterText() {
        return { __html: sectionFooterBlurb };
    }
    return (
        <BrandedTableContainer>
            <Wrapper className="title-container">
                <h3>{sectionTitle}</h3>
                <p>{sectionBlurb}</p>
            </Wrapper>
            <Wrapper className="table-wrapper">
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                {tableHeaders &&
                                    tableHeaders.map((header, index) => {
                                        return (
                                            <th key={index}>
                                                {header.headerText}
                                            </th>
                                        );
                                    })}
                            </tr>
                        </thead>
                        <tbody>
                            {cellArray.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        {item &&
                                            item.map((cell, cellIndex) => {
                                                return (
                                                    <td key={cellIndex}>
                                                        {cell.cellText}
                                                    </td>
                                                );
                                            })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className="btn-container">
                        <ul>
                            {largeTableButton && (
                                <li>
                                    <Link to={largeTableButton.url}>
                                        {largeTableButton.title}
                                        <span>
                                            <RightArrow />
                                        </span>
                                    </Link>
                                </li>
                            )}
                            {smallTableButton && (
                                <li>
                                    <Link to={smallTableButton.url}>
                                        {smallTableButton.title}
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <div className="table-footer-container">
                    <div
                        className="content"
                        dangerouslySetInnerHTML={createFooterText()}
                    ></div>
                </div>
            </Wrapper>
        </BrandedTableContainer>
    );
};

export default BrandedTable;
